/* eslint-disable no-unused-expressions */
/* eslint-disable arrow-parens */
/* eslint-disable no-var */

const Header = el => {
    var scrollY = 0;
    var oldscrollY;
    var status = 0;
    var oldstatus;
    var dir = 0;
    var elHeight;

    const resize = () => elHeight = el.clientHeight;;

    const change = () => {
        if (status === 0) {
            el.classList.remove('hide');
            el.classList.remove('show');
        }
        if (status === 1) {
            el.classList.remove('show');
            el.classList.add('hide');
        }
        if (status === 2) {
            el.classList.remove('hide');
            el.classList.add('show');
        }
    };

    const scroll = () => {
        scrollY = window.pageYOffset;
        dir = oldscrollY - scrollY > 0 ? 1 : 0;
        if (scrollY > elHeight) {
            status = dir === 0 ? 1 : 2;
            if(ParamsData.accessibilty){
                el.classList.add("dark");
            }
        }
        if (scrollY === 0) {
            status = 0;
            if(ParamsData.accessibilty){
                el.classList.remove("dark");
            }
        }
        oldstatus !== status && change();
        oldstatus = status;
        oldscrollY = scrollY;
    };

    window.addEventListener('scroll', scroll, false);
    window.addEventListener('resize', resize, false);
    resize();
};

export default Header;
